import JobOpeningsCard from "./jobOpeningsCard";
export default JobOpeningsCard;